import { Grid, Select } from '@mantine/core';
import FormHeading from 'apps/Projects/SamplePlans/FormInputs/FormHeading';

import { capitalizeEveryWord } from 'util/stringUtils';
import InputAndLabelGridRow from 'common/Components/InputAndLabelGridRow';

import { useProjectsTranslations } from '../hooks';
import { useSamplePlanFormContext } from '../samplePlanFormContextV2';

import { useCarbonPlanConfigQuery } from './queries';

const LandDetails = () => {
  const translations = useProjectsTranslations();
  const samplePlanForm = useSamplePlanFormContext();
  const { samplePlanConfig } = useCarbonPlanConfigQuery();
  return (
    <>
      <FormHeading text={translations.landDetailsQuestion} mb="xs" />
      <Grid>
        <InputAndLabelGridRow
          elemId="land-details-select"
          label={translations.landType}
          span={5}
          input={
            <Select
              data={samplePlanConfig?.land_types.map((landType) => ({
                value: landType,
                label: capitalizeEveryWord(landType),
              }))}
              id="land-details-select"
              allowDeselect={false}
              {...samplePlanForm.getInputProps('project_type')}
            />
          }
        />
      </Grid>
    </>
  );
};

export default LandDetails;
